(function() {
  vtex.define('shipping/script/mixin/withValidation',[], function() {
    return function() {
      var matchValidationRules, triggerValidationEvent, validators;
      validators = [];
      matchValidationRules = function() {
        var valid, validationFunction, validationResults, _i, _len;
        validationResults = [];
        for (_i = 0, _len = validators.length; _i < _len; _i++) {
          validationFunction = validators[_i];
          valid = validationFunction.call(this);
          if (!(typeof valid === 'boolean' && valid === true)) {
            validationResults.push(valid instanceof Error ? valid : new Error(valid));
          }
        }
        return validationResults;
      };
      triggerValidationEvent = function(validationResults) {
        return this.trigger('componentValidated.vtex', [validationResults]);
      };
      this.setValidators = function(validationFunctionArray) {
        return validators = validationFunctionArray;
      };
      this.isValid = function() {
        var validationResults;
        validationResults = matchValidationRules.call(this);
        return validationResults.length === 0 || validationResults === true;
      };
      this.validate = function(ev) {
        var validationResults;
        if (ev != null) {
          ev.stopPropagation();
        }
        validationResults = matchValidationRules.call(this);
        triggerValidationEvent.call(this, validationResults);
        return validationResults;
      };
      this.updateValidationClass = function() {
        this.clearValidationClass();
        if (this.isValid()) {
          return this.$node.addClass('valid');
        } else {
          return this.$node.addClass('has-error');
        }
      };
      this.clearValidationClass = function() {
        this.$node.removeClass('valid');
        return this.$node.removeClass('has-error');
      };
      return this.after('initialize', function() {
        return this.on('validate.vtex', this.validate);
      });
    };
  });

}).call(this);

